import React from 'react';

const packageBenefits = [
    'Free Doctor Consultation',
    'Welcome Massage',
    '4-5 Treatments per day after doctor consultation',
    'Yoga sessions 4 times a week',
    'Meditation - 2 times a week',
    'Free medicine during the stay',
    'Free Table water',
    'Free WiFi',
    '2 - free excursions for stays up to 14 days or else 1 free excursion',
    'Free herbal tea any time of the day',
];

const treatmentList = [
    'Head Massage',
    'Foot Massage',
    'Face Massage',
    'Full Body Massage',
    'Intensive Massage',
    'Acupuncture',
    'Nasal Cleaning',
    'Steam Bath',
    'Synchron Massage',
    'Shirodhara',
    'Special Massage',
    'Flower Bath (on the last day)',
    'Herbal Bath',
];

const wellnessImage = 'https://images.unsplash.com/photo-1515377905703-c4788e51af15?auto=format&fit=crop&w=1200&q=80';

const Packages = () => {
    return (
        <div className="container mx-auto px-4 py-6 sm:py-8 md:py-12 text-gray-700">
            <div className="mb-8 sm:mb-10 md:mb-12 text-center">
                <h1 className="text-[#114131] text-3xl sm:text-4xl md:text-5xl font-bold mb-3">
                    Ayurveda / Panchakarma Package
                </h1>
            </div>

            <div className="mb-8 overflow-hidden rounded-3xl shadow-xl">
                <img
                    src={wellnessImage}
                    alt="Ayurveda wellness treatment"
                    className="w-full h-[260px] sm:h-[360px] md:h-[450px] object-cover"
                />
            </div>

            <div className="grid gap-6 md:grid-cols-2 mb-10">
                <div className="rounded-3xl border border-[#E6A71A] bg-[#fffaf0] p-6 shadow-md">
                    <h2 className="text-2xl font-bold text-[#114131] mb-3">Single</h2>
                    <p className="text-lg sm:text-xl text-gray-700 leading-relaxed">
                        Full board with Ayurveda/Panchakarma treatments
                    </p>
                </div>

                <div className="rounded-3xl border border-[#E6A71A] bg-[#fffaf0] p-6 shadow-md">
                    <h2 className="text-2xl font-bold text-[#114131] mb-3">Double</h2>
                    <p className="text-lg sm:text-xl text-gray-700 leading-relaxed">
                        Full board with Ayurveda/Panchakarma treatments for 2 people
                    </p>
                </div>
            </div>

            <div className="rounded-3xl bg-[#114131] p-6 sm:p-8 text-white shadow-lg mb-10">
                <p className="text-lg sm:text-xl font-semibold leading-relaxed">
                    Airport pickup and drop service available
                </p>
            </div>

            <div className="bg-white rounded-3xl shadow-lg p-6 sm:p-8 mb-10">
                <p className="text-base sm:text-lg leading-relaxed text-gray-700">
                    If interested, kindly confirm the booking with your intended dates and the time of arrival so that we can make the necessary arrangements in advance.
                </p>
                <p className="mt-4 text-base sm:text-lg leading-relaxed text-gray-700">
                    I have also given you details of the package and also the process and hope it would be useful.
                </p>
            </div>

            <div className="bg-white rounded-3xl shadow-lg p-6 sm:p-8 mb-10">
                <h2 className="text-2xl sm:text-3xl font-bold text-[#114131] mb-5">
                    Ayurveda / Panchakarma package includes
                </h2>
                <ul className="space-y-3">
                    {packageBenefits.map((benefit) => (
                        <li key={benefit} className="flex items-start">
                            <span className="text-[#E6A71A] mr-3 text-xl">✓</span>
                            <span className="text-base sm:text-lg leading-relaxed">{benefit}</span>
                        </li>
                    ))}
                </ul>
            </div>

            <div className="bg-white rounded-3xl shadow-lg p-6 sm:p-8 mb-10">
                <h2 className="text-2xl sm:text-3xl font-bold text-[#114131] mb-5">
                    Process
                </h2>
                <div className="space-y-5 text-base sm:text-lg text-gray-700 leading-relaxed">
                    <p>
                        The package starts, with a welcome massage on the day of arrival. On the second day there will be a doctors consultation during which time the doctor will use the patient’s pulse to determine which areas are weak. Accordingly the doctor will schedule the daily treatment plan. The patient has the opportunity to discuss any issues with the doctor during this time. At this point doctor will determine to which category the patient falls (Vata / Pita or Kapa).
                    </p>
                    <p>
                        On the 2nd or 3rd day the patients will be given medicine for cleaning the stomach (defecation).
                    </p>
                    <p>
                        The doctor will decide the type of treatments (4-5 per day) the patient needs daily depending on the findings. Therefore, it may vary day by day and will be selected from the treatments given below;
                    </p>
                </div>
            </div>

            <div className="bg-[#fffaf0] rounded-3xl shadow-lg p-6 sm:p-8">
                <h2 className="text-2xl sm:text-3xl font-bold text-[#114131] mb-5">
                    Treatments included
                </h2>
                <ul className="grid gap-3 sm:grid-cols-2">
                    {treatmentList.map((treatment) => (
                        <li key={treatment} className="flex items-start rounded-xl border border-[#E6A71A] bg-white p-3">
                            <span className="text-[#E6A71A] mr-3 text-xl">•</span>
                            <span className="text-base sm:text-lg">{treatment}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default Packages;